import "./locationPrimaryContactDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import LocationPrimaryContactDetailsEditComponent
    from "./location-primary-contact-details-edit/locationPrimaryContactDetailsEditComponent";
import LocationPrimaryContactDetailsViewComponent
    from "./location-primary-contact-details-view/locationPrimaryContactDetailsViewComponent";

interface LocationPrimaryContactDetailsViewEditComponentProps {
    locationDetails: any
    onUpdatePrimaryContactDetails: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const LocationPrimaryContactDetailsViewEditComponent = (props: LocationPrimaryContactDetailsViewEditComponentProps) => {
    const {locationDetails, onUpdatePrimaryContactDetails,onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [locationPrimaryContactDetails, setLocationPrimaryContactDetails] = useState<any>(undefined);
    //storing whole location details

    const handlePrimaryContactDetailsUpdate = useCallback((updatedPrimaryContactDetails: any) => {
        onUpdatePrimaryContactDetails(updatedPrimaryContactDetails);
        setMode("view");
    }, [onUpdatePrimaryContactDetails]);

    const handlePrimaryContactDetailsEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (locationDetails) {
            setLocationPrimaryContactDetails(locationDetails);
        }
    }, [locationDetails]);

    useEffect(()=>{
        onModeChange(mode);
    },[mode,onModeChange])

    return (
        <div className={'primary-contact-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <LocationPrimaryContactDetailsViewComponent
                    locationPrimaryContactDetails={locationDetails?.primaryContactDetails}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" &&
                <LocationPrimaryContactDetailsEditComponent locationDetails={locationPrimaryContactDetails}
                                                    locationId={locationDetails.id}
                                                    onUpdateComplete={handlePrimaryContactDetailsUpdate}
                                                    onEditCancel={handlePrimaryContactDetailsEditCancel}
                />
            }
        </div>
    );

};

export default LocationPrimaryContactDetailsViewEditComponent;
